// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import PlusOutlinedSvg from "@ant-design/icons-svg/lib/asn/PlusOutlined";
import AntdIcon from "../components/AntdIcon";
const PlusOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: PlusOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    PlusOutlined.displayName = "PlusOutlined";
}
export default /*#__PURE__*/ React.forwardRef(PlusOutlined);
